import React from 'react';
import s from './Processing.module.scss';

const Processing = () => {
    return (
        <div className={s.loaderContainer}>
            <div className={s.wrapper}>
                <div className={s.loaderWrapper}>
                    <div className={s.loader}></div>
                </div>
                <h1 className={s.title}>
                    Processing...
                </h1>
                <div className={s.textWrapper}>
                    <p className={s.text}>
                        Your order is being processed now. This may take a couple of minutes.
                    </p>
                    <p className={s.text}>
                        <span className={'text-violin'}>Please</span> do not refresh the page or click the “Back” or
                        “Close”
                        button of your browser.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Processing;